/* Marine Spec product story: on desktop the picture beside the chapters follows the chapter that is passing the middle of the screen.
   Without JS the first picture stays and every chapter shows its own picture on small screens. */
(function () {
  var g = document.querySelector('[data-ms-pgroup]');
  if (!g || !('IntersectionObserver' in window)) return;
  var figs = [].slice.call(g.querySelectorAll('[data-ms-pfig]'));
  var chs = [].slice.call(g.querySelectorAll('[data-ms-pch]'));
  if (figs.length < 2) return;
  g.classList.add('is-js');
  var show = function (i) {
    var hit = figs.some(function (f) { return f.getAttribute('data-i') === i; });
    if (!hit) return;
    figs.forEach(function (f) { f.classList.toggle('is-on', f.getAttribute('data-i') === i); });
  };
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) show(en.target.getAttribute('data-i')); });
  }, { rootMargin: '-42% 0px -50% 0px' });
  chs.forEach(function (c) { io.observe(c); });
})();
